module.exports = __webpack_public_path__ + "static/media/linkedin-dark.3824f940.svg";